export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_7e1b7837-b42c-4f46-9cd9-58d2696c11e3/artifacts/zc43hhp4_Junk%20removal%20logo%20%2810%29.png";

export const HERO_BEFORE =
    "https://customer-assets.emergentagent.com/job_property-value-co/artifacts/71n8lp8e_IMG_5935.avif";

export const HERO_AFTER =
    "https://customer-assets.emergentagent.com/job_property-value-co/artifacts/x43ihqq0_Untitled%20design%20%2871%29.png";

export const FEATURED_PROJECT_RESIDENTIAL =
    "https://customer-assets.emergentagent.com/job_property-value-co/artifacts/x43ihqq0_Untitled%20design%20%2871%29.png";

export const FEATURED_PROJECT_COMMERCIAL =
    "https://customer-assets.emergentagent.com/job_property-value-co/artifacts/rhkj653y_IMG_6507.avif";

export const FRANK_PHOTO =
    "https://customer-assets.emergentagent.com/job_property-value-co/artifacts/g2mza1xw_Website%20Bio%20page%20%28005%29.png";

export const COMPANY = {
    name: "Bevel Commercial Services",
    phone: "(918) 300-3797",
    phoneHref: "tel:+19183003797",
    email: "info@bevelcommercial.com",
    emailHref: "mailto:info@bevelcommercial.com",
    address: "5272 S. Lewis Ave #322, Tulsa, OK 74105",
    serviceArea: "Tulsa · Owasso · Greater Oklahoma",
};

export const PROJECT_TYPES = [
    "Residential Renovation",
    "Commercial Build-Out",
    "Real Estate Pre-Listing Prep",
    "Industrial",
    "Interior Design",
    "Other",
];

export const NAV_LINKS = [
    { label: "Home", to: "/" },
    { label: "Real Estate", to: "/real-estate-partner" },
    { label: "Commercial", to: "/commercial-projects" },
    { label: "Residential", to: "/residential-renovations" },
    { label: "About", to: "/about" },
    { label: "Contact", to: "/contact" },
];
